
export enum LoginTab {
    ForgotPassword,
    Login
}